// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f1a7f2f","667":"f024937a","977":"cc8d97e5"}[chunkId] + ".chunk.js";
};